/* Customer Reviews Slider — vanilla JS, no dependencies */
(function () {
'use strict';
function initSlider(root) {
var track = root.querySelector('[data-reviews-track]');
if (!track) return;
var prevBtn = root.querySelector('[data-reviews-prev]');
var nextBtn = root.querySelector('[data-reviews-next]');
function slideAmount() {
var slide = track.querySelector('.reviews-slider__slide');
if (!slide) return 0;
var gap = parseFloat(getComputedStyle(track).gap) || 0;
return slide.getBoundingClientRect().width + gap;
}
function updateArrows() {
if (!prevBtn || !nextBtn) return;
var max = track.scrollWidth - track.clientWidth - 2;
prevBtn.disabled = track.scrollLeft <= 2;
nextBtn.disabled = track.scrollLeft >= max;
}
if (prevBtn) {
prevBtn.addEventListener('click', function () {
track.scrollBy({ left: -slideAmount(), behavior: 'smooth' });
});
}
if (nextBtn) {
nextBtn.addEventListener('click', function () {
track.scrollBy({ left: slideAmount(), behavior: 'smooth' });
});
}
track.addEventListener('scroll', updateArrows, { passive: true });
window.addEventListener('resize', updateArrows);
updateArrows();
}
function initFadeIn(root) {
var cards = root.querySelectorAll('[data-review-card]');
if (!cards.length) return;
if (!('IntersectionObserver' in window)) {
cards.forEach(function (card) {
card.classList.add('is-visible');
});
return;
}
var observer = new IntersectionObserver(
function (entries) {
entries.forEach(function (entry) {
if (entry.isIntersecting) {
entry.target.classList.add('is-visible');
observer.unobserve(entry.target);
}
});
},
{ threshold: 0.15 }
);
cards.forEach(function (card) {
observer.observe(card);
});
}
function initLightbox(root) {
var lightbox = root.querySelector('[data-reviews-lightbox]');
if (!lightbox) return;
var img = lightbox.querySelector('[data-reviews-lightbox-image]');
var closeBtn = lightbox.querySelector('[data-reviews-lightbox-close]');
function openLightbox(src) {
img.src = src;
lightbox.hidden = false;
document.body.style.overflow = 'hidden';
}
function closeLightbox() {
lightbox.hidden = true;
img.src = '';
document.body.style.overflow = '';
}
root.addEventListener('click', function (event) {
var trigger = event.target.closest('[data-reviews-lightbox-trigger]');
if (trigger) {
event.preventDefault();
openLightbox(trigger.getAttribute('data-full-src'));
}
});
if (closeBtn) {
closeBtn.addEventListener('click', closeLightbox);
}
lightbox.addEventListener('click', function (event) {
if (event.target === lightbox) {
closeLightbox();
}
});
document.addEventListener('keydown', function (event) {
if (event.key === 'Escape' && !lightbox.hidden) {
closeLightbox();
}
});
}
function initAll() {
document.querySelectorAll('[data-reviews-slider]').forEach(function (root) {
initSlider(root);
initFadeIn(root);
initLightbox(root);
});
}
if (document.readyState === 'loading') {
document.addEventListener('DOMContentLoaded', initAll);
} else {
initAll();
}
document.addEventListener('shopify:section:load', initAll);
})();